import { render, staticRenderFns } from "./PlotAliases.vue?vue&type=template&id=4ca64a6e"
import script from "./PlotAliases.vue?vue&type=script&lang=js"
export * from "./PlotAliases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports